import React,{useState,useEffect} from 'react';
import { Singleton } from '../../../js/Singleton';
import { outBoundCall, framesCamp,phoneIcon } from '../../../Images/Images';
import StopWatchPreview from '../../Header/StopWatch/StopWatchPreview';
import {AgentButton, useToasts} from 'global-components-library';
import { STATES_TO_SHOW_CTC, USER_STATE} from '../../../constants';
import SelectComponent from '../Others/SelectComponent';
import { reprogramacion1} from '../../../Images/Images'; 
import { incrementDiscardedRegisters} from '../../../redux/actions/A_preview';
import { useDispatch, useSelector} from 'react-redux';
import { actionPreviewRecord } from '../../../redux/actions/A_messages_to_SM';
import ChangeTypeCampaign from './ChangeTypeCampaign/ChangeTypeCampaign';
import { SingletonSharedData } from '../../../js/singletonSharedData';

const language = new Singleton();


const CallHeaderPreview = ({campaignName,iconCallFrame,callKey,seconds,phones,isRunning,userState,setPhoneToCall}) => {
    const [hours, setHours] = useState(Math.floor(seconds / 3600));
    const [minutes,setMinutes]= useState(Math.floor(seconds / 60));
    const [sec,setSec] = useState(seconds%60);
    const [isSetTime,setIsSetTime] = useState(false);
    const { addToast } = useToasts();
    const [numbersList,setNumbersList] = useState([]);
    const [displayedComponent,setDisplayedComponent]= useState('1');
    const [objectPhones,setObjectPhones] = useState([]);
    const [timerDesign,setTimerDesign]= useState('');
    const {isTimeAscending, phoneToCall, countRecords, camId, callOutId, initPreviewTime} = useSelector(state=>state.preview);
    const { allowChangeDialing } = useSelector(state=>state.agentPermissions);


    const dispatch = useDispatch();
    const sharedData = new SingletonSharedData();
   
    useEffect(() => {
      let numbers = phones.map(function(dato, i) {
        return {id: i, img: reprogramacion1,number:dato};
      });
      setObjectPhones(numbers);
      timerDesignChange();

    }, [])

    useEffect(() => {
      if(objectPhones.length > 0 && numbersList.length === 0){
        setNumbersList(objectPhones);
      }
    }, [objectPhones])
  
    useEffect(() => {
      setIsSetTime(false);
      if(seconds>0){
          setHours(Math.floor(seconds / 3600));
          setMinutes(Math.floor((seconds % 3600) / 60));
          setSec(seconds%60);
          setIsSetTime(true);
        } else{
          setIsSetTime(true);
        }
    }, [isRunning,seconds]);

    const timeIsOver = message => {
      addToast(message, {
        group: 'icon', 
        position: 'topRight',
        icon: 'warning', 
        color: 'yellow', 
        btnComponent: <AgentButton type='tertiary'>{language.getText("GUIAlertMessageok")}</AgentButton>,
        timeout: 5000, 
      });
    };
    
    const onTimeOver = () =>{
      if(userState !== USER_STATE.WRAPUP)
      {
        dispatch(actionPreviewRecord({process:2, camId:camId, callOutId:callOutId, previewTime:initPreviewTime, callId:0}));
        if(countRecords < 2) timeIsOver(language.getText('GUIAlertMessagepreviewTimeExpired'));
        setTimeout(() => {dispatch(incrementDiscardedRegisters())},100);  
      }      
    }

    const selectPhone = (phone) =>{
      setPhoneToCall(phone.number);
    }
    
    const timerDesignChange=()=>{
      if(userState === USER_STATE.WRAPUP){
        setTimerDesign('wrapUpDesign');
      } else if(userState === USER_STATE.AGENT_PREVIEW || userState === USER_STATE.CALL_OUT){
        setTimerDesign('previewDesign');
      }
    }

    return (
      <div className='containerHeader'>
        <div className="dataCallContainer">
          <div className="campInfo">
            <div className="campaingAssistedIcon">
            <img className='iconCallImageA' src={outBoundCall} alt='icon' />
              <img className='iconCallImageA iconPaddingA' src={iconCallFrame > 0 ? framesCamp[iconCallFrame] : ''} alt='iconCallImage' />
            </div>
            <p className="campName">{campaignName}</p>
          </div>
          <div className="clientInfo">
            { userState !== USER_STATE.AGENT_PREVIEW  ?
             <div className="telContainer">
                <div className='chp-conteinerPhoneCallKey'>
                  <div className={'chp-containerPhoneNumber outboundDesign' }>
                    <img className={'iconCampACD outBoundCall'} src={phoneIcon} alt='icon' />
                    <p className='phoneNumber'>{phoneToCall}</p>
                  </div>
                </div>
              </div> :
              <div className="telContainer">
                { numbersList.length>0 && 
                  <SelectComponent
                    bottomBox={60}
                    defaultDiv={{ item: "texSelection" }}
                    displayer={"bigDisplayer"}
                    customCell={"cellImageText"}
                    parameters={{ image: "img", text: "number" }}
                    dataSource={numbersList}
                    closeOthers={true}
                    itemDefault={0}
                    displayedList={displayedComponent}
                    onSelectItem={selectPhone} />}
                </div>
              }
            <div className="chp-callKeyContainer">
              <p className='chp-textCallKey' >{language.getText('GUICallSpacecallkey')}</p>
              <p className='chp-numberCallKey' >{callKey}</p>
            </div>
          </div>
        </div>
        {(allowChangeDialing && sharedData.getDataPreviewPro().dialingMode && STATES_TO_SHOW_CTC.includes(userState)) && <div className='changeTypeCampaign_container'><ChangeTypeCampaign /></div> }
        <div className="chp-timerContainer">
          <p className={`timeCallBold ${timerDesign}`}>
                {isSetTime && 
                <StopWatchPreview
                  onTimeOver={onTimeOver}
                  hours={hours}
                  minutes={minutes}
                  secondsInitial={sec}
                  isRunning={isRunning}
                  isTimeAscending={isTimeAscending}
                  userState={userState}
                />}
              </p>
               <div className='chp-recordContainer'>
               {userState !== USER_STATE.WRAPUP &&<div className={'headerRecording on'}>
                  <p className='labelTimePreview'>{language.getText('GUIPreviewtimePreviewMode')}</p>
                </div>}
              </div>
        </div>
    </div>          
    )
}
export default CallHeaderPreview;


// WEBPACK FOOTER //
// ./src/components/workSpace/CallComponents/CallHeaderPreview.jsx